import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ten-article-feature-video',
  templateUrl: './article-feature-video.component.html',
  styleUrls: ['./article-feature-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, MatIconModule],
})
export class ArticleFeatureVideoComponent implements OnInit {
  public heroVideo: SafeResourceUrl;
  public allowAutoplay = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    public dialogRef: MatDialogRef<ArticleFeatureVideoComponent>,
    public domSanitizer: DomSanitizer
  ) {}

  public ngOnInit() {
    this.heroVideo = this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.data}?autoplay=${this.allowAutoplay}`);
  }

  public closePopup() {
    this.dialogRef.close();
  }
}
